import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router'
import { Modal, CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab'

// Styles
import '../../assets/styles.css'

// Logo
import logo_trans from '../../assets/logo_trans.png';

// Firebase
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default function HomepageComponent() {

    const history = useHistory()

    // Loading
    const [isLoadingModalOpen, setLoaginModalOpen] = useState(false)

    // Snackbar
    const [alertSeverity, setAlertSeverity] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertDuration, setAlertDuration] = useState(3000)
    const [alertOpen, setAlertOpen] = useState(false)

    function showAlert(severity, message, duration) {
        setAlertSeverity(severity)
        setAlertMessage(message)
        setAlertDuration(duration)
        setAlertOpen(true)
    }

    function checkedLogedIn() {
        firebase.auth().onAuthStateChanged((user) => {
            if(!user){
                history.replace('/login')
            }
        })
    }

    function signOut() {
        setLoaginModalOpen(true)
        firebase.auth().signOut().then(() => {

            setLoaginModalOpen(false)
            history.replace('/login')

        }).catch((error) => {
            setLoaginModalOpen(false)
            console.error(error.code)
            showAlert('error', 'Ha ocurrido un error, inténtalo más tarde.', 3000)
        })
    }

    // Add funds
    const [isAddFundsOpen, setAddFundsOpen] = useState(false)

    function addFunds() {

        const userID = document.getElementById('appUserIDInput').value.toString().trim()
        const amount = document.getElementById('amountInput').value.toString().trim().replace(',', '.')

        if (userID !== '' && amount !== '') {

            setLoaginModalOpen(true)

            let floatAmount = Number.parseFloat(amount)

            if(isNaN(floatAmount)) {
                setLoaginModalOpen(false)
                showAlert('error', 'Escribe un importe válido.', 3000)
                return
            }

            firebase.firestore().collection('users').doc(userID).get().then((user) => {
                if (user.exists) {

                    const data = user.data()

                    const strWallet = data.wallet

                    if (strWallet === undefined || strWallet === '' || strWallet === '00.00') {

                        const newStrWallet = (Math.round(floatAmount * 100) / 100).toFixed(2).toString()
                        
                        firebase.firestore().collection('users').doc(userID).update({wallet: newStrWallet}).then(() => {

                            setLoaginModalOpen(false)
                            document.getElementById('appUserIDInput').value = ''
                            document.getElementById('amountInput').value = ''
                            setAddFundsOpen(false)
                            showAlert('success', 'Fondos añadidos con éxito!', 3000)

                        }).catch((error) => {
                            console.error(error)
                            setLoaginModalOpen(false)
                            showAlert('error', 'Ha ocurrido un error, inténtalo más tarde.', 3000)
                            return
                        })

                    } else {
                        const floatWallet = Number.parseFloat(strWallet)
                        const newWallet = floatWallet + floatAmount
                        const newStrWallet = (Math.round(newWallet * 100) / 100).toFixed(2).toString()

                        firebase.firestore().collection('users').doc(userID).update({wallet: newStrWallet}).then(() => {

                            setLoaginModalOpen(false)
                            document.getElementById('appUserIDInput').value = ''
                            document.getElementById('amountInput').value = ''
                            setAddFundsOpen(false)
                            showAlert('success', 'Fondos añadidos con éxito!', 3000)

                        }).catch((error) => {
                            console.error(error)
                            setLoaginModalOpen(false)
                            showAlert('error', 'Ha ocurrido un error, inténtalo más tarde.', 3000)
                            return
                        })
                    }

                } else {
                    setLoaginModalOpen(false)
                    showAlert('error', 'Este usuario no existe.', 3000)
                    return
                }
            }).catch((err) => {
                console.error(err)
                setLoaginModalOpen(false)
                showAlert('error', 'Ha ocurrido un error, inténtalo más tarde.', 3000)
                return
            })
        }

    }

    useEffect(() => {
        checkedLogedIn()
    }, [])

    return(
        <div>
            <div className='container' >
                <br></br>
                {
                    // Sign Out
                }
                <div className='row'>
                    <div className='col text-end'>
                        <button type='button' className='btn btn-primary-transparent'
                        onClick={() => {
                            signOut()
                        }} >
                            <i className="fas fa-power-off" style={{ fontSize: 25}} ></i>
                        </button>
                    </div>
                </div>
                {
                    // Logo
                }
                <div className='row' style={{ width: '100%'}}>
                    <div className='col-sm-1 col-md-2 col-lg-4 col-xl-4 col-xxl-4'></div>
                    <div className='col-sm-10 col-md-8 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                        <img src={logo_trans} style={{ width: '55%' }} alt='This is a logo' ></img>
                    </div>
                    <div className='col-sm-1 col-md-2 col-lg-4 col-xl-4 col-xxl-4'></div>
                </div>
                {
                    // Menu
                }
                <br></br>
                <br></br>
                <div className='row' style={{ width: '100%'}}>
                    <div className='col-sm-1 col-md-2 col-lg-4 col-xl-4 col-xxl-4'></div>
                    <div className='col-sm-10 col-md-8 col-lg-4 col-xl-4 col-xxl-4 text-center'>
                        <div className='row'>
                            <div className='col text-center'>
                                <div className='btn-primary' style={{ padding: 10, borderRadius: 5, margin: 5 }}
                                onClick={() => {
                                    history.push('/verify')
                                }} >
                                    <i className="fas fa-user-check" style={{ fontSize: 50 }} ></i>
                                    <h6 style={{ marginTop: 10 }} >Verificación de usuarios</h6>
                                </div>
                            </div>
                            <div className='col text-center'>
                                <div className='btn-primary' style={{ padding: 10, borderRadius: 5, margin: 5 }}
                                onClick={() => {
                                    history.push('/withdraw')
                                }} >
                                    <i className="fas fa-hand-holding-usd" style={{ fontSize: 50 }} ></i>
                                    <h6 style={{ marginTop: 10 }} >Peticiones de fondos</h6>
                                </div>
                            </div>
                            <div className='col text-center'>
                                <div className='btn-primary' style={{ padding: 10, borderRadius: 5, margin: 5 }}
                                onClick={() => {
                                    setAddFundsOpen(true)
                                }} >
                                    <i className="fas fa-dollar-sign" style={{ fontSize: 50 }} ></i>
                                    <h6 style={{ marginTop: 10 }} >Añadir fondos</h6>
                                </div>
                            </div>
                            <div className='col text-center'>
                                <div className='btn-primary' style={{ padding: 10, borderRadius: 5, margin: 5 }}
                                onClick={() => {
                                    history.push('/usersC')
                                }} >
                                    <i className="fas fa-users" style={{ fontSize: 50 }} ></i>
                                    <h6 style={{ marginTop: 10 }} >Control de usuarios</h6>
                                </div>
                            </div>
                            <div className='col text-center'>
                                <div className='btn-primary' style={{ padding: 10, borderRadius: 5, margin: 5 }}
                                onClick={() => {
                                    history.push('/ranking')
                                }} >
                                    <i className="fas fa-flag-checkered" style={{ fontSize: 50 }} ></i>
                                    <h6 style={{ marginTop: 10 }} >Ranking de personal médico</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-1 col-md-2 col-lg-4 col-xl-4 col-xxl-4'></div>
                </div>
            </div>
            <br></br>
            {/**
             * 
             * MODAL ZONE
             * 
             */}
            <Modal
            disableEnforceFocus
            open={isLoadingModalOpen} >
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}} >
                    <CircularProgress color='inherit' style={{ color: '#FB3D44', marginTop: 25 }} />
                </div>
            </Modal>
            <Modal
            disableEnforceFocus
            open={isAddFundsOpen} >
                <div style={{ display: 'flex', justifyContent: 'center', height: '100%', alignItems: 'center'}} >
                    <div style={{ backgroundColor: 'white', borderRadius: 10, padding: 20, display: 'flex', flexDirection: 'column'}} >
                        <button className='btn' style={{ color: 'gray', alignSelf: 'flex-end' }}
                        onClick={() => {
                            setAddFundsOpen(false)
                        }} >
                            <i className="fas fa-times"></i>
                        </button>
                        <h4 style={{ color: '#FB3D44' }} >
                            Añadir fondos a establecimiento
                        </h4>
                        <div className='blue-divider'></div>
                        <div className="mb-3">
                            <label className="form-label">ID de usuario: </label>
                            <input type='text' className="form-control" id="appUserIDInput" placeholder="bQzobKLXtbWl1xg4fm3R2ibOdta2"/>
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Importe: </label>
                            <input className="form-control" id="amountInput" placeholder="15.00"/>
                        </div>
                        <button className="btn btn-primary" style={{ width: '100%' }}
                        onClick={() => {
                            addFunds()
                        }} >
                            Añadir
                        </button>
                    </div>
                </div>
            </Modal>
            {/**
             * 
             * SNACKBAR
             * 
             */}
            <Snackbar
            open={alertOpen}
            autoHideDuration={alertDuration}
            onClose={() => {
                setAlertOpen(false)
            }} >
                <Alert 
                variant='filled'
                severity={alertSeverity} >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/home/HomepageComponent.js